import { Injectable } from "@angular/core";
import {
  IFillToleranceService,
  CHANNEL_FILL_TOLERANCE_SERVICE,
  DetailFillToleranceResponse,
} from "../IFillToleranceService";
import { Subject } from "rxjs";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { FillOrderData } from "../../model/core/FillOrderData";

export abstract class FillTolerancePromiseService implements IFillToleranceService {
  abstract checkQuickFillTolerance(orders: Array<CubiqTS.OrderDataImpl>): Promise<any>;
  abstract checkDetailFillTolerance(
    fillorderData: Array<FillOrderData>,
  ): Promise<DetailFillToleranceResponse>;
}
